import { ChangeRequestStatusBase } from './base/change-request-status-base';

export class ChangeRequestStatus extends ChangeRequestStatusBase { }